import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, ASSETS, WEBSERVICE } from "../utils/init";
import {
  showToast,
  _isOnlyNumber,
  showHttpError,
  currentPageAccess,
  handleDynamicCurrencyDetiails,
  getCurrencyWiseTxnCharge,
} from "../utils/library";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FetchUsdBtcLedgerAmount,
  get_customer_details,
  send_payment_request,
  GetMarketPrice,
  FetchMerchantSettings,
  CalculateTransactionFee
} from "../utils/service";

import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "../assets/css/style.css";

const vs = {
  pageWrapper: {
    padding: "36px 24px 60px",
  },
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "28px",
  },
  backBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "var(--text-color)",
    fontSize: "15px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  infoCard: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 92%), color-mix(in srgb, var(--btn-color), transparent 96%))",
    borderRadius: "12px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
    padding: "20px 24px",
    marginBottom: "28px",
  },
  infoItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    marginBottom: "10px",
    fontSize: "13px",
    lineHeight: "1.5",
  },
  infoIcon: {
    color: "var(--btn-color)",
    fontSize: "14px",
    marginTop: "2px",
    flexShrink: 0,
  },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    overflow: "hidden",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 85%), color-mix(in srgb, var(--btn-color), transparent 92%))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardHeaderIconText: {
    fontSize: "16px",
    color: "var(--btn-color)",
  },
  cardHeaderIconTeal: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "color-mix(in srgb, #14b8a6, transparent 88%)",
    color: "#14b8a6",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  cardHeaderTitle: {
    fontSize: "15px",
    fontWeight: "700",
    margin: 0,
  },
  cardBody: {
    padding: "24px 28px",
  },
  formRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px",
  },
  formGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    color: "var(--text-color)",
    opacity: 0.7,
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    boxSizing: "border-box",
  },
  inputReadOnly: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    opacity: 0.7,
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    appearance: "auto",
  },
  errorText: {
    fontSize: "11px",
    color: "#ef4444",
    marginTop: "4px",
    fontWeight: "500",
  },
  inputWithSuffix: {
    position: "relative",
  },
  inputSuffix: {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: "12px",
    fontWeight: "700",
    color: "var(--btn-color)",
    pointerEvents: "none",
  },
  submitArea: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    padding: "20px 28px",
    borderTop: "1px solid var(--body-color-less2)",
  },
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "11px 32px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnSecondary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "11px 32px",
    background: "#10b981",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  btnDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
  },
  generatedSection: {
    marginTop: "8px",
  },
  generatedHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  textarea: {
    width: "100%",
    height: "260px",
    padding: "16px",
    fontSize: "12px",
    fontFamily: "monospace",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    boxSizing: "border-box",
    resize: "vertical",
  },
  btnCopy: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "8px 20px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  previewLabel: {
    fontSize: "13px",
    fontWeight: "600",
    opacity: 0.5,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginTop: "24px",
    marginBottom: "16px",
  },
  previewCard: {
    background: "var(--body-color)",
    borderRadius: "12px",
    border: "1px solid var(--body-color-less2)",
    padding: "24px",
  },
};

class RecurringPaymentRequest extends React.Component {
  marketPrice = null;

  constructor(props) {
    super(props);

    this.state = {
      customerEmail: "",
      customerEmailPreview: "",
      emailIdError: false,
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      yourEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      recurringPeriod: "",
      amountCharged: "",
      cryptoPrice: null,
      cryptoUsedCurrencyId: "",
      cryptoUsedCurrencyCode: "",
      billingCycleStartsOn: null,
      formatedDate: "",
      totalBillingCycles: "",
      paymentAttemptsCount: null,
      paymentAttemptsCountError: false,
      totalBillingCyclesError: false,
      assets: [],
      generateCodeButtonDisabled: false,
      requestRecurringPaymentButtonDisabled: false,
      recurringOptions: ["DAILY", "WEEKLY", "MONTHLY", "YEARLY"],
      formHtml: "",
      showPreview: false,
      assetsList: [],
      permission: "",
      isActiveUntilCancelled: false,
      marketPrice: 0,
      // ── Processing Fee Handling ──
      processingFeeHandling: "customer",  // "customer" = 1, "merchant" = 0
      processingFeePct: 0,
      processingFeeAmt: 0,
      totalAmount : 0,
      // ── txn charge for selected currency ──
      txnCharge: null,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      assetsList: ASSETS,
      permission: currentPageAccess(),
    });
    this.renderMerchantProcessingFeeType();
    this.handleRenderLedgerAmount();
  }

  renderMerchantProcessingFeeType = async () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let processingFeesType = response.is_processing_fee_enabled;
            this.setState({
              processingFeeHandling: parseInt(processingFeesType) === 1 ? 'customer' : 'merchant',
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  }

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  isFormValid = () => {
    var isAllFieldsFilled =
      this.state.customerEmail !== "" &&
      this.state.merchantId !== "" &&
      this.state.yourEmail !== "" &&
      this.state.recurringPeriod !== "" &&
      this.state.amountCharged !== "" &&
      this.state.cryptoUsedCurrencyId !== "" &&
      this.state.billingCycleStartsOn !== null &&
      this.state.totalBillingCycles !== "" &&
      this.state.paymentAttemptsCount !== null &&
      !this.state.emailIdError &&
      !this.state.paymentAttemptsCountError &&
      !this.state.totalBillingCyclesError;

    var isExceptCustomerEmailFilled =
      this.state.merchantId !== "" &&
      this.state.yourEmail !== "" &&
      this.state.recurringPeriod !== "" &&
      this.state.amountCharged !== "" &&
      this.state.cryptoUsedCurrencyId !== "" &&
      this.state.totalBillingCycles !== "" &&
      this.state.paymentAttemptsCount !== null &&
      !this.state.paymentAttemptsCountError &&
      !this.state.totalBillingCyclesError;

    return { isAllFieldsFilled, isExceptCustomerEmailFilled };
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    showToast("success", "Successfully copied to clipboard");
  };

  handleRenderLedgerAmount = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }
              const currencyOrder = ['USDC', 'USDT', 'XRP', 'DOGE', 'HCX', 'ETH', 'BTC', 'LTC', 'BCH'];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                localStorage.setItem(
                  SITENAMEALIAS + "_assets",
                  JSON.stringify(this.state.assets)
                );
                // Set USDC as default currency
                const usdc = arr.find(a => a.assetCode === 'USDC');
                if (usdc) {
                  this.setState({
                    cryptoUsedCurrencyId: usdc.assetId,
                    cryptoUsedCurrencyCode: usdc.assetCode,
                  });
                  this.getMarketPrice(usdc.assetCode);
                }
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleChange = (event) => {
    var { name, value } = event.target;

    if (
      name === "amountCharged" ||
      name === "totalBillingCycles" ||
      name === "paymentAttemptsCount"
    ) {
      if (name === "totalBillingCycles") {
        if (value === "" || /^\d+$/.test(value)) {
          const numVal = parseInt(value, 10);
          if (value === "") {
            this.setState({ totalBillingCycles: "", totalBillingCyclesError: false });
          } else if (numVal > 999) {
            this.setState({ totalBillingCycles: value, totalBillingCyclesError: true });
          } else {
            this.setState({ totalBillingCycles: value, totalBillingCyclesError: false });
          }
        }
      } else if (_isOnlyNumber(value)) {
        this.setState({ [name]: value });
        if (name === "amountCharged") {
          this.getConvertedPrice();
        }
      } else {
        this.setState({ [name]: "" });
      }
    } else if (name === "cryptoUsedCurrencyId") {
      var selectedOption = handleDynamicCurrencyDetiails(
        this.state.assets,
        value
      );
      this.setState(
        {
          cryptoUsedCurrencyId: selectedOption.assetId,
          cryptoUsedCurrencyCode: selectedOption.assetCode,
        },
        () => {
          // ── Refresh txn charge for newly selected currency ──
          this.fetchTxnCharge(selectedOption.assetCode);
        }
      );
      this.getMarketPrice(selectedOption.assetCode);
    } else if (name === "customerEmail") {
      this.setState({ [name]: value, customerEmailPreview: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSubmit = (event) => {
    if (this.state.permission == "WRITE") {
      event.preventDefault();
      this.customerEmailValidation();
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  customerEmailValidation = () => {
    let payload = { email: this.state.customerEmail };
    this.setState({ showLoader: true });

    get_customer_details(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            this.setState({ showLoader: false });
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              this.sendPaymentRequest();
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  sendPaymentRequest = async () => {
    const isCustomerPays = this.state.processingFeeHandling === "customer";
    const is_processing_fee_applied = isCustomerPays ? 1 : 0;

    const processingFeesResponse = await CalculateTransactionFee(localStorage.getItem(SITENAMEALIAS + "_merchant_id"), this.state.cryptoUsedCurrencyId, this.state.amountCharged);
    const processingFees = processingFeesResponse.data;
    if (processingFees.error !== '0') {
      showToast('error', processingFees.error_msg);
      return;
    }
    this.setState({
      processingFeePct: processingFees.txnCharge,
      processingFeeAmt: processingFees.transactionFee,
      totalAmount : processingFees.totalAmount
    })

    const totalAmount = isCustomerPays ? processingFees.totalAmount : this.state.amountCharged;

    let payload = {
      customer_email: this.state.customerEmail,
      merchant_email: this.state.yourEmail,
      recurring_period: this.state.recurringPeriod,
      amount: totalAmount,
      currency_code: this.state.cryptoUsedCurrencyCode,
      start_date: this.state.formatedDate,
      total_cycles: this.state.totalBillingCycles,
      attempt: this.state.paymentAttemptsCount,
      is_processing_fee_applied,
      processing_fee_pct: isCustomerPays ? processingFees.txnCharge : 0,
      processing_fee_amt: isCustomerPays ? processingFees.transactionFee : 0,
    };

    send_payment_request(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "success",
              "Recurring Payment request sent successfully !!!"
            );
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleDateChange = (date) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month = parseInt(date.getMonth()) + 1;
    if (parseInt(month) < 10) month = "0" + month;
    let day = date.getDate();
    if (parseInt(day) < 10) day = "0" + day;
    let formatedDate = year + "-" + month + "-" + day;
    this.setState({ billingCycleStartsOn: date, formatedDate: formatedDate });
  };

  getConvertedPrice = () => {
    if (this.state.amountCharged === "") {
      this.setState({ cryptoPrice: null });
      return;
    }
    if (
      this.state.cryptoUsedCurrencyCode != "" &&
      this.state.amountCharged != ""
    ) {
      let convertedPrice =
        parseFloat(this.state.amountCharged) /
        parseFloat(this.state.marketPrice);
      this.setState({ cryptoPrice: convertedPrice.toFixed(6) });
    }
  };

  getMarketPrice = (currency_code) => {
    GetMarketPrice(currency_code)
      .then(
        function (res) {
          let response = res.data;
          this.setState({ marketPrice: Number(response.price) }, () => {
            this.getConvertedPrice();
          });
        }.bind(this)
      )
      .catch(function (err) {
        console.log(err);
      });
  };

  handleEmailId = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
    if (regex.test(elm)) {
      this.setState({ emailIdError: false });
    } else {
      this.setState({ emailIdError: true, customerEmail: "" });
    }
  };

  handleGenerateCodeClick = async () => {
    if (this.state.permission == "WRITE") {
      let html = "";
      const exchangeName = localStorage.getItem(SITENAMEALIAS + "_exchange");
      const processingFeesResponse = await CalculateTransactionFee(localStorage.getItem(SITENAMEALIAS + "_merchant_id"), this.state.cryptoUsedCurrencyId, this.state.amountCharged);
      const processingFees = processingFeesResponse.data;
      if (processingFees.error !== '0') {
        showToast('error', processingFees.error_msg);
        return;
      }
      this.setState({
        processingFeePct: processingFees.txnCharge,
        processingFeeAmt: processingFees.transactionFee,
        totalAmount: processingFees.totalAmount
      })
      html += `
        <!DOCTYPE html>
        <html>

        <head>
            <meta charset="UTF-8">
            <meta content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" name="viewport">

            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css"
                integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">

                <style>
                .swal2-popup {
                    text-align: unset;
                }
                #customerEmail::placeholder {
                    color: #999;
                    font-style: italic;
                }

                .email-info .info-button{
                    position: absolute;
                    border: 0px;
                    background: none;
                    color: grey;
                    top: 0px;
                    right: 0px;
                }


                input[readonly] {
                    pointer-events: none;
                    cursor: default;
                    user-select: none;
                    -webkit-user-select: none;
                    background: #e9ecef !important;
                    color: #6c757d;
                    border-color: #dee2e6;
                }

                .text-danger{
                    color: #ff0854 !important;
                }

                .form-container {
                    height: auto;
                    width: auto;
                    padding: 10px;
                    margin-top: 30px;
                }

                .text-center {
                    text-align: center !important;
                }

                .currencyPostData{
                    position: absolute;
                    right: 6px;
                    top: 9px;
                    color: #0052ff;
                    font-weight: bold;
                 }

                .recurring-form {
                    width: 100%;
                    border-radius: 10px;
                    margin: 0 auto;
                    border: 1px solid rgb(255, 255, 255, 0.5);
                    padding: 20px;
                    background: #23293100;
                    box-shadow: 2px 5px 20px rgba(119, 119, 119, 0.5);
                }

                .recurring-form-label {
                    width: 100%;
                    margin-top: 20px;
                }

                .recurring-form-placeholder-text {
                    color: #002691;
                }

                .email-info{
                    position: relative;
                  }

                  .email-info .tooltip-text{
                    visibility: hidden;
                    box-shadow: 2px 5px 20px rgba(119, 119, 119, 0.5);
                    width: 500px;
                    background-color: #66a68d;
                    color: #fff;
                    text-align: center;
                    border-radius: 10px;
                    padding: 10px;
                    position: absolute;
                    z-index: 1;
                    margin-top: 37px;
                    right: 0px;
                    left: 460px;
                    bottom: -170px;
                    text-align: unset;
               }

               .email-info .tooltip-text::after {
                    content: "";
                    position: absolute;
                    bottom: 100%;
                    margin-left: -465px;
                    border-width: 5px;
                    border-style: solid;
                    border-color: transparent transparent #66a68d transparent;
               }

                  .email-info:hover .tooltip-text {
                    visibility: visible;
                  }

                .loader {
                    position: absolute;
                    top: 50%;
                    left: 45%;
                    transform: translate(-50%, -50%);
                    border: 16px solid #f3f3f3;
                    border-radius: 50%;
                    border-top: 16px solid #3498db;
                    width: 100px;
                    height:100px;
                    -webkit-animation: spin 2s linear infinite;
                    animation: spin 2s linear infinite;
                    display: none;
                }

                div:where(.swal2-container) .swal2-html-container{
                    text-align: justify !important;
                }

                /* Safari */
                @-webkit-keyframes spin {
                0% { -webkit-transform: rotate(0deg); }
                100% { -webkit-transform: rotate(360deg); }
                }

                @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
                }
            </style>
            <script src="https://cdn.jsdelivr.net/npm/sweetalert2@11"></script>
            <script src="https://code.jquery.com/jquery-3.6.4.min.js" crossorigin="anonymous"></script>

            <link rel="stylesheet" href="https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css">
            <script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

            <script>

                $(function() {
                    function initializeDatepicker() {
                        $("#formattedDate").datepicker({
                            minDate: 0
                        });
                    }
                    initializeDatepicker();
                });

                function showToast (type,message) {
                    Swal.fire({
                        position: "center",
                        icon: type,
                        title: message,
                        showConfirmButton: false,
                        timer: 4000
                    });
                }

                function showConfirm  (title,text,type,callback)  {
                    Swal.fire({
                        title: title,
                        html: text,
                        icon: type,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.value) {
                            callback();
                        }
                    })
                }


                function showHttpError(error) {
                    if(error.response != undefined){
                        var code = error.response.status;
                        if(code == '401' || (error.toString()).indexOf('401')!= -1){
                        showToast('error','Session Timeout')
                        handleLogout();
                        }else if(code == '403'){
                        showToast('error','403 error')
                        handleLogout();
                        }else if(code == '404' || code == '403' || code == '400'){
                        showToast('error','Failed to connect with the server');
                        }else if(code == '500'){
                        showToast('error','Internal Server Error');
                        }else{
                        showToast('error',code + ' : Technical Error');
                        }
                    }else{
                        showToast('error',error)
                    }
               }


                function handleEmailId(event) {
                    let elm = event.target.value;
                    let regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\\.[a-zA-Z]{2,}$/;
                    let emailErrorMessage = document.getElementById('emailErrorMessage');

                    if (regex.test(elm)) {
                        emailErrorMessage.style.display = 'none';
                    } else {
                        emailErrorMessage.style.display = 'block';
                    }
                }

                function generateRequest(event) {
                    event.preventDefault();
                    document.getElementById('loader').style.display = 'block';
                    var customerEmail = document.getElementById('customerEmail').value;
                    var yourEmail = document.getElementById('yourEmail').value;
                    var recurringPeriod = document.getElementById('recurringPeriod').value;
                    var amountCharged = document.getElementById('amountCharged').value;
                    var cryptoUsedCurrencyCode = document.getElementById('cryptoUsedCurrencyCode').value;
                    var formattedDateElement = document.getElementById('formattedDate');
                    var totalBillingCycles = document.getElementById('totalBillingCycles').value;
                    var paymentAttemptsCount = document.getElementById('paymentAttemptsCount').value;

                    var formattedDate = formattedDateElement.value;

                    var dateObj = new Date(formattedDate);
                    var year = dateObj.getFullYear();
                    var month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    var day = String(dateObj.getDate()).padStart(2, '0');
                    var formattedDateStr = year + '-' + month + '-' + day;

                    let processingFeeType = document.getElementById('processingFeeType').value;
                    let processingFeePct = document.getElementById('processingFeePct').value;
                    let processingFeeAmt = document.getElementById('processingFeeAmt').value;
                    let payload = {
                        customer_email: customerEmail,
                        merchant_email: yourEmail,
                        recurring_period: recurringPeriod,
                        amount: amountCharged,
                        currency_code: cryptoUsedCurrencyCode,
                        start_date: formattedDateStr,
                        total_cycles: totalBillingCycles,
                        attempt: paymentAttemptsCount,
                        is_processing_fee_applied: processingFeeType,
                        processing_fee_pct: processingFeePct,
                        processing_fee_amt: processingFeeAmt,
                    };

                    var apiUrl = '${WEBSERVICE}/recurring_payment/send_payment_request';

                    $.ajax({
                        url: apiUrl,
                        type: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(payload),
                        success: function (data) {
                            document.getElementById('loader').style.display = 'none';
                            let responseData = data[0];
                            if (responseData.error !== 0) {
                                showToast("error", responseData.error_msg);
                            } else {
                                showConfirm("Recurring Payment request sent successfully", "You are required to login the PayBitoPro Exchange and approve this recurring payment by going to Payments > Recurring Payments > 'View payment requested by merchant or subscribed by you on merchant websites' tab.<br/><br/>Please note that you must hold and maintain balance in the crypto you are using to subscribe here, in your PaybitoPro wallet to pay for the subscription.", "success", () => {
                                    location.reload();
                                });
                            }
                        },
                        error: function (xhr, status, error) {
                            document.getElementById('loader').style.display = 'none';
                            showHttpError(error);
                        }
                    });
                }
            </script>

        </head>

        <body>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-container">
                            <form class="recurring-form" onsubmit="generateRequest(event);">
                                <h3 class="text-center" style="margin-bottom:20px;">Subscribe to a recurring payment</h3>

                                <input type="hidden" id="processingFeeType" value="${this.state.processingFeeHandling === "customer" ? 1 : 0}"/>
                                <input type="hidden" id="processingFeePct" value="${this.state.processingFeeHandling === "customer" ? processingFees.txnCharge : 0}"/>
                                <input type="hidden" id="processingFeeAmt" value="${this.state.processingFeeHandling === "customer" ? processingFees.transactionFee : 0}"/>
                                <input type="hidden" id="paymentAttemptsCount" value="${this.state.paymentAttemptsCount}" />

                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="recurring-form-label">Customer Email:</label>
                                        <input type="text" class="form-control" id="customerEmail" name="customerEmail" onchange="handleEmailId(event)" placeholder="Input your email here" required/>
                                        <small class="text-danger" id="emailErrorMessage" style="display: none;">
                                            Please insert a valid email
                                        </small>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="recurring-form-label">Your Merchant ID:</label>
                                        <input type="text" id="merchantId" name="merchantId" value="${this.state.merchantId}" class="form-control" readonly tabindex="-1" />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="recurring-form-label">Your Email:</label>
                                        <input type="text" id="yourEmail" name="yourEmail" value="${this.state.yourEmail}" class="form-control" readonly tabindex="-1" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="recurring-form-label">Recurring Period:</label>
                                        <input type="text" id="recurringPeriod" name="recurringPeriod" value="${this.state.recurringPeriod}" class="form-control" readonly tabindex="-1" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="recurring-form-label">Amount charged per recurring period:</label>
                                        <div style="position:relative">
                                            <input type="text" id="amountCharged" name="amountCharged" value="${this.state.processingFeeHandling === 'customer' ? processingFees.totalAmount : this.state.amountCharged}" class="form-control" readonly tabindex="-1" />
                                            <span class="currencyPostData" style="font-weight:lighter;color:#000">USD</span>
                                        </div>
                                    </div>
                                </div>

                                ${this.state.processingFeeHandling === "customer" ? '<div class="row"><div class="col-md-12"><label class="recurring-form-label">Processing Fee:</label><input type="text" class="form-control" value="' + processingFees.txnCharge + '% (' + processingFees.transactionFee + ' ' + this.state.cryptoUsedCurrencyCode + ')" readonly tabindex="-1" /></div></div>' : ''}

                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="recurring-form-label">Crypto that will be used to make payments:</label>
                                        <input type="text" id="cryptoUsedCurrencyCode" name="cryptoUsedCurrencyCode" value="${this.state.cryptoUsedCurrencyCode}" class="form-control" readonly tabindex="-1" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="recurring-form-label">Billing cycle starts on which date?:</label>
                                        <input type="text" id="formattedDate" name="formattedDate" value="${this.state.formatedDate}" class="form-control" required/>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label class="recurring-form-label">Total number of billing cycles:</label>
                                        <input type="text" id="totalBillingCycles" name="totalBillingCycles" value="${this.state.isActiveUntilCancelled ? 'No end date' : this.state.totalBillingCycles}" class="form-control" readonly tabindex="-1" />
                                    </div>
                                    <div class="col-md-6" style="display:flex;align-items:flex-end;padding-bottom:5px;">
                                        <label style="display:flex;align-items:center;gap:6px;">
                                            <input type="checkbox" ${this.state.isActiveUntilCancelled ? 'checked' : ''} disabled /> No end date
                                        </label>
                                    </div>
                                </div>

                                <div class="row" style="margin-top:20px;">
                                    <div class="col-md-12 text-center">
                                        <button type="submit" class="btn btn-primary">Subscribe now</button>
                                    </div>
                                </div>

                                <div class="row" style="margin-top:20px;">
                                    <div class="col-md-12">
                                        <p style="font-size:12px;color:#666;text-align:center;line-height:1.6;">
                                            This recurring payment will show up when you log in to your ${exchangeName} account. You will need to enable it from there in order to activate it. Login to your ${exchangeName} account and click on "Recurring payments" from the Payments menu. Go to the tab "View payment requested by merchants or subscribed by you on merchant websites" and enable or cancel this payment.
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="loader" class="loader"></div>
                    </div>
                </div>
            </div>
        </body>
        </html>
        `;

      this.setState({ formHtml: html, showPreview: true });
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  handlePaymentAttemptsCount = (e) => {
    if (e.target.value > 10 || e.target.value < 0) {
      this.setState({
        paymentAttemptsCountError: true,
        paymentAttemptsCount: null,
      });
    } else {
      this.setState({ paymentAttemptsCountError: false });
    }
  };

  render() {
    const exchangeName = localStorage.getItem(SITENAMEALIAS + "_exchange");
    const brokerDomain = localStorage.getItem("brokerDomain");
    const { processingFeeHandling, txnCharge } = this.state;

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={vs.pageWrapper}>
              {/* Back + Title */}
              <div style={vs.backRow}>
                <div
                  style={vs.backBtn}
                  onClick={() =>
                    this.props.history.push("/recurring-payment-list")
                  }
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </div>
                <div>
                  <h2 style={vs.pageTitle}>Request Recurring Payment</h2>
                  <div style={vs.pageSubtitle}>
                    Set up a subscription for your customers. They must have an
                    account on {exchangeName} with recurring payments enabled.
                  </div>
                </div>
              </div>

              {/* Info Tips */}
              <div style={vs.infoCard}>
                <div style={vs.infoItem}>
                  <i className="fas fa-circle-check" style={vs.infoIcon}></i>
                  <span>
                    You can request recurring payments{" "}
                    <strong>[subscriptions]</strong> for your customers.
                  </span>
                </div>
                <div style={vs.infoItem}>
                  <i className="fas fa-circle-check" style={vs.infoIcon}></i>
                  <span>
                    Your customer must have an account in {exchangeName}.{" "}
                    <a
                      href={brokerDomain + "signup"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-signup-blue"
                    >
                      Sign up here
                    </a>
                  </span>
                </div>
                <div style={{ ...vs.infoItem, marginBottom: 0 }}>
                  <i className="fas fa-circle-check" style={vs.infoIcon}></i>
                  <span>
                    Customer must enable recurring payments in {exchangeName}{" "}
                    under Payments &gt; Recurring Payments.
                  </span>
                </div>
              </div>

              {/* Form Card */}
              <form onSubmit={this.handleSubmit}>
                {/* Section 1: Customer & Schedule */}
                <div style={vs.card}>
                  <div style={vs.cardHeader}>
                    <div style={vs.cardHeaderIcon}>
                      <i
                        className="fas fa-user"
                        style={vs.cardHeaderIconText}
                      ></i>
                    </div>
                    <h3 style={vs.cardHeaderTitle}>Customer & Schedule</h3>
                  </div>
                  <div style={vs.cardBody}>
                    <div style={vs.formRow}>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Customer Email *</label>
                        <input
                          type="text"
                          style={vs.input}
                          name="customerEmail"
                          value={this.state.customerEmail}
                          onChange={this.handleChange}
                          onBlur={this.handleEmailId}
                          placeholder="Enter customer email"
                        />
                        {this.state.emailIdError && (
                          <span style={vs.errorText}>
                            Please insert a valid email
                          </span>
                        )}
                      </div>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Recurring Period *</label>
                        <select
                          style={vs.select}
                          name="recurringPeriod"
                          value={this.state.recurringPeriod}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="" hidden>
                            Select period
                          </option>
                          {this.state.recurringOptions.map((option) => (
                            <option key={option} value={option}>
                              {option.charAt(0).toUpperCase() +
                                option.slice(1).toLowerCase()}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div style={vs.formRow}>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Billing Start Date *</label>
                        <DatePicker
                          selected={this.state.billingCycleStartsOn}
                          dateFormat="yyyy-MM-dd"
                          placeholderText="Choose a start date"
                          className="form-control"
                          onChange={(date) => this.handleDateChange(date)}
                          minDate={new Date()}
                          wrapperClassName="w-100"
                        />
                      </div>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Total Number of Billing Cycles *</label>
                        <input
                          type="text"
                          style={{
                            ...vs.input,
                            ...(this.state.isActiveUntilCancelled ? { opacity: 0.4, pointerEvents: "none" } : {}),
                          }}
                          name="totalBillingCycles"
                          value={this.state.isActiveUntilCancelled ? "" : this.state.totalBillingCycles}
                          onChange={this.handleChange}
                          placeholder="e.g. 12"
                          required={!this.state.isActiveUntilCancelled}
                          disabled={this.state.isActiveUntilCancelled}
                        />
                        {this.state.totalBillingCyclesError && (
                          <span style={vs.errorText}>
                            Maximum value is 999
                          </span>
                        )}
                        <label style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "8px", cursor: "pointer", fontSize: "13px", color: "var(--text-color)" }}>
                          <input
                            type="checkbox"
                            checked={this.state.isActiveUntilCancelled}
                            onChange={(e) => this.setState({
                              isActiveUntilCancelled: e.target.checked,
                              totalBillingCycles: e.target.checked ? "0" : "",
                            })}
                            style={{ accentColor: "var(--btn-color)" }}
                          />
                          No end date
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── Processing Fee Handling Card ── */}
                <div style={vs.card}>
                  <div style={vs.cardHeader}>
                    <div style={vs.cardHeaderIconTeal}>
                      <i className="fa fa-percent"></i>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <h3 style={vs.cardHeaderTitle}>Processing Fee Handling</h3>
                      {txnCharge != null && (
                        <span style={{
                          fontSize: "11px", fontWeight: "700", color: "#14b8a6",
                          background: "color-mix(in srgb, #14b8a6, transparent 88%)",
                          borderRadius: "6px", padding: "2px 8px",
                        }}>
                          {txnCharge}
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={vs.cardBody}>
                    <p style={{ fontSize: "13px", color: "var(--text-color)", opacity: 0.55, margin: "0 0 16px" }}>
                      Choose how transaction fees are applied for this payment.
                    </p>
                    <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>

                      {/* Option 1 — Customer pays */}
                      <label
                        onClick={() => this.setState({ processingFeeHandling: "customer" })}
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "14px",
                          padding: "16px 20px",
                          borderRadius: "12px",
                          border: processingFeeHandling === "customer"
                            ? "2px solid var(--btn-color)"
                            : "2px solid color-mix(in srgb, var(--text-color), transparent 88%)",
                          background: processingFeeHandling === "customer"
                            ? "color-mix(in srgb, var(--btn-color), transparent 94%)"
                            : "var(--body-color)",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          margin: 0,
                          userSelect: "none",
                        }}
                      >
                        <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                          <div style={{
                            width: "18px", height: "18px", borderRadius: "50%",
                            border: processingFeeHandling === "customer"
                              ? "5px solid var(--btn-color)"
                              : "2px solid color-mix(in srgb, var(--text-color), transparent 60%)",
                            background: "var(--body-color)",
                            transition: "all 0.2s ease",
                          }} />
                        </div>
                        <div>
                          <div style={{ fontSize: "14px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                            The customer pays the processing fee
                          </div>
                          <div style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.55, lineHeight: 1.4 }}>
                            {txnCharge != null
                              ? `${txnCharge} ${this.state.cryptoUsedCurrencyCode} will be added to the checkout total.`
                              : "The fee will be added to the checkout total."}
                          </div>
                        </div>
                      </label>

                      {/* Option 2 — Merchant absorbs */}
                      <label
                        onClick={() => this.setState({ processingFeeHandling: "merchant" })}
                        style={{
                          flex: 1,
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "14px",
                          padding: "16px 20px",
                          borderRadius: "12px",
                          border: processingFeeHandling === "merchant"
                            ? "2px solid var(--btn-color)"
                            : "2px solid color-mix(in srgb, var(--text-color), transparent 88%)",
                          background: processingFeeHandling === "merchant"
                            ? "color-mix(in srgb, var(--btn-color), transparent 94%)"
                            : "var(--body-color)",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          margin: 0,
                          userSelect: "none",
                        }}
                      >
                        <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                          <div style={{
                            width: "18px", height: "18px", borderRadius: "50%",
                            border: processingFeeHandling === "merchant"
                              ? "5px solid var(--btn-color)"
                              : "2px solid color-mix(in srgb, var(--text-color), transparent 60%)",
                            background: "var(--body-color)",
                            transition: "all 0.2s ease",
                          }} />
                        </div>
                        <div>
                          <div style={{ fontSize: "14px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                            Merchant absorbs the processing fee
                          </div>
                          <div style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.55, lineHeight: 1.4 }}>
                            {txnCharge != null
                              ? `${txnCharge} ${this.state.cryptoUsedCurrencyCode} will be deducted from your payout.`
                              : "The fee will be deducted from your payout."}
                          </div>
                        </div>
                      </label>

                    </div>
                  </div>
                </div>
                {/* ── End Processing Fee Handling Card ── */}

                {/* Section 2: Payment Details */}
                <div style={vs.card}>
                  <div style={vs.cardHeader}>
                    <div style={vs.cardHeaderIcon}>
                      <i
                        className="fas fa-coins"
                        style={vs.cardHeaderIconText}
                      ></i>
                    </div>
                    <h3 style={vs.cardHeaderTitle}>Payment Details</h3>
                  </div>
                  <div style={vs.cardBody}>
                    <div style={vs.formRow}>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>
                          Amount Per Period (USD) *
                        </label>
                        <div style={vs.inputWithSuffix}>
                          <input
                            type="text"
                            style={{ ...vs.input, paddingRight: "50px" }}
                            name="amountCharged"
                            value={this.state.amountCharged}
                            onChange={this.handleChange}
                            placeholder="0.00"
                            required
                          />
                          <span style={vs.inputSuffix}>USD</span>
                        </div>
                      </div>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Crypto Currency *</label>
                        <select
                          style={vs.select}
                          name="cryptoUsedCurrencyId"
                          value={this.state.cryptoUsedCurrencyId}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="" hidden>
                            Select crypto
                          </option>
                          {this.state.assets.map((option) => (
                            <option
                              key={option.assetCode}
                              value={option.assetId}
                            >
                              {option.assetCode}
                            </option>
                          ))}
                        </select>
                        {this.state.cryptoUsedCurrencyCode === "USDT" && (
                          <span style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.55, marginTop: "6px" }}>
                            Your customer will be able to send USDT via the following networks: Ethereum, Tron, Polygon, and BSC.
                          </span>
                        )}
                      </div>
                    </div>

                    {this.state.cryptoPrice !== null && (
                      <div style={vs.formRow}>
                        <div style={vs.formGroup}>
                          <label style={vs.label}>
                            Estimated Crypto Price
                            <i
                              className="fas fa-circle-info"
                              style={{
                                marginLeft: "6px",
                                fontSize: "11px",
                                opacity: 0.5,
                              }}
                              title="The crypto amount shown is indicative based on current market price. Actual amount will be calculated at the time of payment."
                            ></i>
                          </label>
                          <div style={vs.inputWithSuffix}>
                            <input
                              type="text"
                              style={vs.inputReadOnly}
                              name="cryptoPrice"
                              value={this.state.cryptoPrice}
                              readOnly
                            />
                            <span style={vs.inputSuffix}>
                              {this.state.cryptoUsedCurrencyCode}
                            </span>
                          </div>
                        </div>
                        <div style={vs.formGroup}></div>
                      </div>
                    )}

                    <div style={vs.formRow}>
                      <div style={vs.formGroup}>
                        <label style={vs.label}>Payment Retry Attempts *</label>
                        <input
                          type="text"
                          style={vs.input}
                          name="paymentAttemptsCount"
                          value={
                            this.state.paymentAttemptsCount === null
                              ? ""
                              : this.state.paymentAttemptsCount
                          }
                          onChange={this.handleChange}
                          onBlur={this.handlePaymentAttemptsCount}
                          placeholder="Max 10 attempts"
                          required
                        />
                        {this.state.paymentAttemptsCountError && (
                          <span style={vs.errorText}>
                            Maximum number of attempts is 10
                          </span>
                        )}
                      </div>
                      <div style={vs.formGroup}></div>
                    </div>
                  </div>

                  {/* Submit Buttons */}
                  <div style={vs.submitArea}>
                    <button
                      type="submit"
                      style={{
                        ...vs.btnPrimary,
                        ...(!this.isFormValid().isAllFieldsFilled ||
                          this.state.requestRecurringPaymentButtonDisabled
                          ? vs.btnDisabled
                          : {}),
                      }}
                      disabled={
                        !this.isFormValid().isAllFieldsFilled ||
                        this.state.requestRecurringPaymentButtonDisabled
                      }
                    >
                      <i
                        className="fas fa-paper-plane"
                        style={{ fontSize: "13px" }}
                      ></i>
                      Send Payment Request
                    </button>
                    <button
                      type="button"
                      style={{
                        ...vs.btnSecondary,
                        ...(!this.isFormValid().isExceptCustomerEmailFilled ||
                          this.state.generateCodeButtonDisabled
                          ? vs.btnDisabled
                          : {}),
                      }}
                      onClick={this.handleGenerateCodeClick}
                      disabled={
                        !this.isFormValid().isExceptCustomerEmailFilled ||
                        this.state.generateCodeButtonDisabled
                      }
                    >
                      <i
                        className="fas fa-code"
                        style={{ fontSize: "13px" }}
                      ></i>
                      Generate Embed Code
                    </button>
                  </div>
                </div>
              </form>

              {/* Generated Code Section */}
              {this.state.showPreview && (
                <div style={vs.generatedSection}>
                  <div style={vs.card}>
                    <div style={vs.generatedHeader}>
                      <h3 style={vs.cardHeaderTitle}>Generated Code</h3>
                      <button
                        type="button"
                        style={vs.btnCopy}
                        onClick={() => this.copyCodeToClipboard()}
                      >
                        <i
                          className="fas fa-copy"
                          style={{ fontSize: "12px" }}
                        ></i>
                        Copy Code
                      </button>
                    </div>
                    <div style={vs.cardBody}>
                      <p
                        style={{
                          fontSize: "13px",
                          opacity: 0.6,
                          marginBottom: "16px",
                        }}
                      >
                        Select the HTML code below, then copy and paste it into
                        your webpage.
                      </p>
                      <textarea
                        style={vs.textarea}
                        ref={(textarea) => (this.textArea = textarea)}
                        value={this.state.formHtml}
                        readOnly
                      ></textarea>

                      <p style={vs.previewLabel}>Preview</p>

                      <div style={vs.previewCard}>
                        <form onSubmit={(e) => e.preventDefault()}>
                          <h3 style={{ fontSize: "18px", fontWeight: "700", textAlign: "center", marginBottom: "24px", color: "var(--text-color)" }}>
                            Subscribe to a recurring payment
                          </h3>

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Customer Email</label>
                              <input
                                type="text"
                                style={vs.input}
                                name="customerEmailPreview"
                                value={this.state.customerEmailPreview}
                                onChange={this.handleChange}
                                placeholder="Input your email here"
                              />
                            </div>
                          </div>

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Your Merchant ID</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.merchantId}
                                readOnly
                              />
                            </div>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Your Email</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.yourEmail}
                                readOnly
                              />
                            </div>
                          </div>

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Recurring Period</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.recurringPeriod ? this.state.recurringPeriod.charAt(0).toUpperCase() + this.state.recurringPeriod.slice(1).toLowerCase() : ""}
                                readOnly
                              />
                            </div>
                          </div>

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Amount Charged Per Recurring Period</label>
                              <div style={vs.inputWithSuffix}>
                                <input
                                  type="text"
                                  style={{
                                    ...vs.inputReadOnly,
                                    paddingRight: "50px",
                                  }}
                                  value={this.state.processingFeeHandling === "customer" ? this.state.totalAmount : this.state.amountCharged}
                                  readOnly
                                />
                                <span style={vs.inputSuffix}>USD</span>
                              </div>
                            </div>
                          </div>

                          {this.state.processingFeeHandling === "customer" && this.state.processingFeePct > 0 && (
                            <div style={vs.formRow}>
                              <div style={vs.formGroup}>
                                <label style={vs.label}>Processing Fee</label>
                                <input
                                  type="text"
                                  style={vs.inputReadOnly}
                                  value={`${this.state.processingFeePct}% (${this.state.processingFeeAmt} ${this.state.cryptoUsedCurrencyCode})`}
                                  readOnly
                                />
                              </div>
                            </div>
                          )}

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Crypto That Will Be Used to Make Payments</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.cryptoUsedCurrencyCode}
                                readOnly
                              />
                            </div>
                          </div>

                          <div style={vs.formRow}>
                            <div style={vs.formGroup}>
                              <label style={vs.label}>Billing Cycle Starts On Which Date?</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.formatedDate || ""}
                                readOnly
                              />
                            </div>
                          </div>

                          <div style={vs.formRow}>
                            <div style={{ ...vs.formGroup, flex: "unset" }}>
                              <label style={vs.label}>Total Number of Billing Cycles</label>
                              <input
                                type="text"
                                style={vs.inputReadOnly}
                                value={this.state.isActiveUntilCancelled ? "No end date" : this.state.totalBillingCycles}
                                readOnly
                              />
                            </div>
                            <div style={{ display: "flex", alignItems: "flex-end", paddingBottom: "4px" }}>
                              <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "default", fontSize: "13px", color: "var(--text-color)" }}>
                                <input
                                  type="checkbox"
                                  checked={this.state.isActiveUntilCancelled}
                                  readOnly
                                  style={{ accentColor: "var(--btn-color)" }}
                                />
                                No end date
                              </label>
                            </div>
                          </div>

                          <div
                            style={{ textAlign: "center", marginTop: "16px" }}
                          >
                            <button type="submit" style={vs.btnPrimary}>
                              Subscribe Now
                            </button>
                          </div>

                          <p style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.55, lineHeight: 1.6, marginTop: "20px", textAlign: "center" }}>
                            This recurring payment will show up when you log in to your {exchangeName} account. You will need to enable it from there in order to activate it. Login to your {exchangeName} account and click on "Recurring payments" from the Payments menu. Go to the tab "View payment requested by merchants or subscribed by you on merchant websites" and enable or cancel this payment.
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Hidden fields preserved for form logic */}
              <input
                type="hidden"
                name="merchantId"
                value={this.state.merchantId}
              />
              <input
                type="hidden"
                name="yourEmail"
                value={this.state.yourEmail}
              />
            </div>

            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default withRouter(RecurringPaymentRequest);